import { Injectable } from '@angular/core';
import { CloudFunctionsApiService } from '../../services/cloud-functions-api.service';

@Injectable({
  providedIn: 'root',
})
export class AIService {
  constructor(private api: CloudFunctionsApiService) {}

  getStrings() {
    return this.api.snapshotList('/metadata?type=ai_string');
  }

  saveString(data) {
    return this.api.post('/metadata', data).toPromise();
  }

  addData(data) {
    return this.api.post('/warnings', data).toPromise();
  }

  getWords() {
    return this.api.snapshotList('/metadata?type=bullying_word');
  }

  compareWord(word) {
    return this.api.snapshotList(`/metadata?type=bullying_word&word=${encodeURIComponent(word)}`);
  }

  getWordsNow() {
    return this.api.getCollection('/metadata?type=bullying_word');
  }
}
